export default "__VITE_ASSET__BD$DcEFp__"